import $ from 'jquery';

// hax because calling $("#print a").trigger('click'); doesn't work
// this is sources from /sponge/app/assets/javascripts/print_preview.js
export default function() {
  var $window = $(window);
  var printStylesheets = $("link[media=print]");

  $window.scrollTop(0);
  $window.trigger("printPreviewEnable");

  printStylesheets.attr("data-original-media", "print").prop("media", "all");
  $("body").addClass("print-preview");

  $window.trigger("printPreviewEnabled");
}
